import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import React, { useState } from "react";

import styled from "styled-components/macro";

import { faCommentAlt } from "@fortawesome/pro-light-svg-icons";
import { AnimatePresence, motion } from "framer-motion";

import { useInterval } from "Utilities/Hooks/useInterval";

import getRandomIcon from "./icons.js";

export default function FnrLoadingCarousel({ show, whiteBackground }) {
  return (
    <AnimatePresence>
      {show && (
        <Wrapper
          $whiteBackground={whiteBackground}
          initial={{ opacity: 1, scale: 0.7, y: 80 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{
            scale: 0.7,
            opacity: 0,
            y: 80,
            transition: {
              type: "tween",
              duration: 0.3,
              ease: "backIn",
            },
          }}
        >
          <LargeIcon icon={faCommentAlt} />
          <ImageCarousel whiteBackground={whiteBackground} />
        </Wrapper>
      )}
    </AnimatePresence>
  );
}

FnrLoadingCarousel.propTypes = {
  show: PropTypes.bool,
  whiteBackground: PropTypes.bool,
};

const Wrapper = styled(motion.div)`
  position: absolute;
  z-index: 1000;
  top: 50%;
  left: 50%;
  width: 240px;
  height: 240px;
  margin-left: -120px;
  margin-top: -120px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #278dc1;

  &::after {
    content: "";
    position: absolute;
    bottom: 55px;
    left: 50%;
    transform: translateX(-62%) translateY(-12%);
    width: 0;
    height: 0;
    border-right: 27px solid transparent;
    border-top: 20px solid
      ${({ $whiteBackground }) => ($whiteBackground ? "#fff" : "transparent")};
  }
`;

const LargeIcon = styled(FontAwesomeIcon)`
  font-size: 132px;
  margin-top: 20px;
`;

export function ImageCarousel({ whiteBackground }) {
  const [icon, setIcon] = useState(getRandomIcon());

  useInterval(() => setIcon(getRandomIcon()), 500);

  return (
    <CarouselWrapper $whiteBackground={whiteBackground}>
      <AnimatePresence>
        <CarouselIcon
          key={"icon-" + icon}
          className={"fa-" + icon}
          initial={{ opacity: 0, x: "100%" }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: "-100%" }}
        />
      </AnimatePresence>
    </CarouselWrapper>
  );
}

ImageCarousel.propTypes = {
  whiteBackground: PropTypes.bool,
};

const CarouselWrapper = styled.div`
  height: 89px;
  margin-top: -5px;
  width: 114px;
  margin-left: 0px;
  border-radius: 8px;
  position: absolute;
  overflow: hidden;
  background: ${({ $whiteBackground }) =>
    $whiteBackground ? "#fff" : "transparent"};
  border: ${({ $whiteBackground }) =>
    $whiteBackground ? "1px solid #fff" : "none"};
`;

const CarouselIcon = styled(motion.div)`
  font-size: 60px;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export function FlexibleFnrLoadingCarousel({ show, whiteBackground }) {
  return (
    <AnimatePresence>
      {show && (
        <FlexibleWrapper
          $whiteBackground={whiteBackground}
          initial={{ opacity: 1, scale: 0.7, y: 80 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{
            scale: 0.7,
            opacity: 0,
            y: 80,
            transition: {
              type: "tween",
              duration: 0.3,
              ease: "backIn",
            },
          }}
        >
          <LargeIcon icon={faCommentAlt} />
          <ImageCarousel whiteBackground={whiteBackground} />
        </FlexibleWrapper>
      )}
    </AnimatePresence>
  );
}

const FlexibleWrapper = styled(motion.div)`
  position: relative;
  width: 240px;
  height: 240px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #278dc1;

  &::after {
    content: "";
    position: absolute;
    bottom: 55px;
    left: 50%;
    transform: translateX(-62%) translateY(-12%);
    width: 0;
    height: 0;
    border-right: 27px solid transparent;
    border-top: 20px solid
      ${({ $whiteBackground }) => ($whiteBackground ? "#fff" : "transparent")};
  }
`;

FlexibleFnrLoadingCarousel.propTypes = {
  show: PropTypes.bool,
  whiteBackground: PropTypes.bool,
};
